// src/sot/primitives/SaveChip.jsx
import React from "react";
import { LanguageContext } from "@/contexts/LanguageContext.jsx";

/**
 * SaveChip — Blueprint-aligned tonal action chip
 * ✅ Defaults to type="button" to avoid accidental form submits.
 * ✅ Forwards props (type, className, aria-*, etc.)
 */
export default function SaveChip({
  type = "button",
  disabled = false,
  onClick,
  label,
  children,
  className = "",
  ...rest
}) {
  const language = React.useContext(LanguageContext);
  const localizedDefault = language?.t
    ? language.t("common.save", "Save")
    : "Save";
  const content = label ?? children ?? localizedDefault;

  return (
    <button
      type={type}
      disabled={disabled}
      onClick={onClick}
      className={[
        "inline-flex items-center justify-center",
        "whitespace-nowrap",
        "min-h-10 rounded-full",
        "px-5 py-2",
        "text-sm font-medium leading-5",
        "transition-colors duration-150",
        "focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2",
        "focus-visible:ring-[rgba(var(--afrimed-primary),0.38)] focus-visible:ring-offset-transparent",
        "disabled:cursor-not-allowed",
        disabled
          ? "bg-[rgba(var(--clr-on-surface),0.08)] text-on-surface opacity-40"
          : "bg-[var(--state-primary-12)] text-primary hover:bg-[var(--state-primary-16)]",
        className,
      ].join(" ")}
      {...rest}
    >
      {content}
    </button>
  );
}
